<template>
  <div>
    <div class="maintitle">{{ $route.meta.title }}</div>
    <el-divider></el-divider>
    <el-row class='text-left' :gutter="10">
      <el-col :span='8'>
        <el-input placeholder="请输入公司名称关键字或会员id" size="mini" v-model='company'></el-input>
      </el-col>
      <el-col :span="8">
        <el-input placeholder="请输入信息关键字" size="mini" v-model="keyword"></el-input>
      </el-col>
      <el-button @click="getlist" class="margin-left" size="mini">搜索</el-button>
    </el-row>
    <el-table :data="list" border>
      <el-table-column prop="id" label="id" width="80" align="center"></el-table-column>
      <el-table-column prop="name" label="产品名称"></el-table-column>
      <el-table-column prop="create_time" label="创建时间"></el-table-column>
      <el-table-column prop="company" label="公司"></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="showInfo(scope.row.id)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize"
                   @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <el-dialog :visible.sync="showInfoDiv" :close-on-click-modal="false">
      <el-form :label-width="formLabelWidth" class="text-left info-form">
        <el-form-item label="产品名称">{{ datumInfo.name }}</el-form-item>
        <el-form-item label="备注" v-if="datumInfo.beizhu !== ''">{{ datumInfo.beizhu }}</el-form-item>
        <el-form-item label="规格">
          <div v-for="(item,index) in datumInfo.detail.specdigest" :key="index">
            {{ item.name }}:{{ getText(item.values, 'value') }}
          </div>
        </el-form-item>
        <el-form-item label="报价方式">
          {{ getQuotationType(datumInfo.quotationType) }}
        </el-form-item>
<!--        <el-form-item label="售卖价格" v-if="datumInfo.quotationType === 1">-->
<!--          <el-table :data="datumInfo.price">-->
<!--            <el-table-column prop="startQuantity" label="起订量"></el-table-column>-->
<!--            <el-table-column prop="price" label="价格"></el-table-column>-->
<!--          </el-table>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="商品价格" v-if="datumInfo.quotationType !== 2">-->
<!--          <el-table :data="datumInfo.specPriceList">-->
<!--            <el-table-column prop="spec" label="商品规格"></el-table-column>-->
<!--            <el-table-column prop="value" label="规格值"></el-table-column>-->
<!--            <el-table-column prop="price" label="商品价格" v-if="datumInfo.quotationType===0"></el-table-column>-->
<!--            <el-table-column prop="stock" label="商品库存"></el-table-column>-->
<!--            <el-table-column label="规格图片">-->
<!--              <template v-slot="scope">-->
<!--                <el-image :src="scope.row.image" v-if="scope.row.image !== ''" fit="contain"></el-image>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--          </el-table>-->
<!--        </el-form-item>-->
        <el-form-item label="在线交易" v-if="datumInfo.quotationType !== 2">{{formatProductType(datumInfo.productType)}}</el-form-item>
        <el-form-item label="安心购" v-if="datumInfo.productType === 'trade'">{{formatAnxinguo(datumInfo.anxingou)}}</el-form-item>
        <el-form-item label="商品分类"> {{ datumInfo.classify }}</el-form-item>
        <el-form-item label="商品关键词">
          <div class="parameters">{{datumInfo.detail.tags}}</div>
          <div class="parameters">{{datumInfo.detail.tags2}}</div>
        </el-form-item>
        <el-form-item label="修饰词行业" class="text-left" v-if="datumInfo.hangyetype===1">
          <el-select size="mini" v-model="datumInfo.hangye" disabled>
            <el-option :value="0" label="通用行业"></el-option>
            <el-option v-for="item in hangyes" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="轮播首图" class="text-left">
          <el-image v-for="(item,index) in datumInfo.detail.firstimage" :key="index" :src="item" fit="contain" :preview-src-list="datumInfo.detail.firstimage"></el-image>
        </el-form-item>
        <el-form-item label="轮播图" class="text-left">
          <el-image v-for="(item,index) in datumInfo.detail.image" :src="item" :key="index" fit="contain" :preview-src-list="datumInfo.detail.image"></el-image>
        </el-form-item>
        <el-form-item label="详情图" class="text-left">
          <div v-for="(item,index) in datumInfo.detail.infoimg" :key="index">
            <el-image v-for="(i,id) in item.pic" :src="i" :key="id" :preview-src-list="item.pic" fit="contain"></el-image>
          </div>
        </el-form-item>
        <el-form-item label="视频" class="text-left">
          <video v-for="(item,index) in datumInfo.detail.video" :key="index" controls>
            <source :src="item" type="video/mp4"/>
          </video>
        </el-form-item>
        <el-form-item label="参数" class="text-left">
          <div v-for="(item,index) in datumInfo.detail.parameters" :key="index">
            <div v-if="item.name!=='' && item.value!==''" class="parameters">{{item.name}}: {{item.value}}</div>
          </div>
        </el-form-item>
        <el-form-item label="发货地">
          <div v-for="(item,index) in datumInfo.area" :key="index">
            <div class="parameters">{{item[1]}}/{{item[2]}}</div>
          </div>
        </el-form-item>
        <el-form-item label="信息发布数量">{{datumInfo.num}}</el-form-item>
        <el-form-item label="每天发布条数">{{datumInfo.daynum}}</el-form-item>
        <el-form-item label="间隔天数">{{datumInfo.interval}}</el-form-item>
        <el-form-item label="开始发布时间">{{datumInfo.starttime}}</el-form-item>
        <el-form-item label="信息标题">
          <el-input size="mini" type="textarea" v-model="datumInfo.detail.title" style="width: 500px" rows="8" readonly></el-input>
        </el-form-item>
        <el-form-item label="产品文字介绍">
          <div v-for="(item,index) in datumInfo.detail.intro" :key="index">
            <el-input size="mini" type="textarea" v-model="item.content" style="width: 500px" rows="8" readonly></el-input>
          </div>
        </el-form-item>
        <el-form-item label="发货地">{{getText(datumInfo.district)}}</el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showInfoDiv = false">取 消</el-button>
        <el-button type="primary" @click="copyInfo(datumInfo.id)">复制</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //资料列表
      page: 1,
      total: 0,
      keyword: "",
      company: '',
      showInfoDiv: false,
      datumInfo: {
        id: 0,
        detail: {
          specdigest: []
        },
        district:[]
      },
      hangyes:[]
    };
  },
  methods: {
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
    },
    // 获取资料列表，注意通过商户id获取对应资料，该设置尚未处理。
    getlist() {
      this.$axios({
        url: this.HOST + "/datum/getList",
        method: "post",
        data: {
          page: this.page,
          pagesize: this.pagesize,
          keyword: this.keyword,
          company: this.company,
        },
      }).then((res) => {
        if (res.data.status === 1) {
          this.list = res.data.list.data;
          this.total = res.data.list.total;
        }
      });
    },
    showInfo(id) {
      this.$axios({
        url: this.HOST + '/datum/getInfo',
        method: 'post',
        data: {
          id: id
        }
      }).then(res => {
        if (res.data.status === 1) {
          this.datumInfo = res.data.info;
          this.showInfoDiv = true;
        }
      })
    },
    copyInfo(id) {
      this.$confirm(
          "确定复制信息吗?本操作不可恢复，而且会占用信息总条数",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
      )
          .then(() => {
            this.loading = true;
            this.$axios({
              url: this.HOST + "/datum/copy",
              method: "post",
              data: {
                id: id,
              },
            }).then((res) => {
                  this.loading = false;
                  if (res.data.status === 1) {
                    this.$message({
                      type:'success',
                      message:res.data.info,
                    })
                    this.showInfoDiv=false;
                  }
                })
                .catch((err) => {
                  console.log(err);
                });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作",
            });
          });
    },
    getText(item, key = '') {
      if (key === '') return item.join('/')
      let temp = [];
      item.forEach((item, index) => {
        temp.push(item.value);
      })
      return temp.join('/');
    },
    getQuotationType(type) {
      switch (type) {
        case 1:
          return '按产品数量报价';
        case 2:
          return '面议';
        case 0:
          return '按产品规格报价';
      }
    },
    formatProductType(productType){
      return productType === 'trade'? '是':'否';
    },
    formatAnxinguo(anxinguo){
      return anxinguo===0?'未开通':'已开通';
    }
  },
  created() {
    this.$axios({
      url:this.HOST+'/datum/getInitInfo',
      method:"post",
    }).then(res=>{
      if(res.data.status === 1){
        this.hangyes = res.data.hangyes;
      }
    })
  },
};
</script>

<style>
.info-form {
  > .div {
    margin-bottom: 0;
  }
  .el-image{
    width:100px;
    aspect-ratio: 1;
    margin:5px;
  }
  video{
    width:100px;
    aspect-ratio: 1;
    margin:5px;
  }
  .el-form-item__content{
    display: flex;
    flex-wrap: wrap;
  }
  .parameters{
    margin:5px;
    background-color:#d3dce6;
    border-radius: 5px;
    padding:0 10px;
  }
}
</style>
